import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { getImportacionApiUrl } from '../config/importacion.config';

@Injectable({ providedIn: 'root' })
export class ImportacionGuard {
	constructor(private readonly router: Router) {}

	canActivate(): boolean | UrlTree {
		return !!getImportacionApiUrl() || this.router.createUrlTree(['/home']);
	}
}
